import { Trophy } from 'lucide-react';
import { MatchList } from '../components/matches/MatchList';
import { Helmet } from 'react-helmet-async';

export function Results() {
  return (
    <>
      <Helmet>
        <title>Results | Molde FK at Aker Stadium</title>
        <meta 
          name="description" 
          content="See all results from matches at Aker Stadium. Get a full overview of Molde FK's performances, goalscorers, and match statistics."
        />
      </Helmet>
      <div className="min-h-screen bg-gray-100">
        <div className="bg-[#2173B9] text-white py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center gap-3 mb-4">
              <Trophy className="w-8 h-8" />
              <h1 className="text-3xl font-bold">Results</h1>
            </div>
            <p className="text-lg opacity-90">
              Previous matches at Aker Stadium
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
            <MatchList type="last" limit={30} />
          </div>

          <div className="bg-white rounded-lg shadow-lg p-6">
            <h2 className="text-2xl font-bold mb-4">Latest Results</h2>
            <p className="text-gray-600 mb-6">
              Stay updated with the latest results from matches at Aker Stadium. Get an overview of 
              how Molde FK has performed in both home and away matches. The results page gives you 
              all the information you need to follow the club's progress throughout the season.
            </p>

            <h3 className="text-xl font-bold mb-3">Detailed Match Statistics</h3>
            <p className="text-gray-600">
              Get access to detailed match statistics from all recent matches at Aker Stadium. See 
              information about goalscorers, possession, cards, and much more. The results page is 
              updated immediately after each match to give you the freshest numbers.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
